import { siteConfig } from '@/config/site'
import { copyToClipboard } from '@/lib/copyToClipboard'

/** Copies provided email (or falls back to `siteConfig.contactEmail`) to clipboard. */
export const copyContactEmail = (email?: string): Promise<boolean> =>
  copyToClipboard(email?.trim() || siteConfig.contactEmail)
